import WiseView from '../../WiseView.vue';
import { frontendURL } from '../../../../../helper/URLHelper';
import ProfileWise from './ProfileWise.vue';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/profile-wise'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'profile_wise',
        component: ProfileWise,
        roles: ['administrator'],
      },
    ],
  },
];
